import type { GetObligationImpactAuditByIdResponseRow } from '@risksmart-app/drizzle/src/dto';
import { GetObligationImpactAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

import type { AuditLogQueryResult } from './auditLogQueryResult';

type UseGetObligationImpactAuditByIdArgs = { id: string };

export const useGetObligationImpactAuditById = createQueryHook<
  UseGetObligationImpactAuditByIdArgs,
  GetObligationImpactAuditByIdResponseRow[],
  AuditLogQueryResult<
    'obligation_impact_audit',
    GetObligationImpactAuditByIdResponseRow
  >
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getObligationImpactAuditById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ obligation_impact_audit: data }),
  graphqlDocument: GetObligationImpactAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ id }),
});
